import { store } from "@store";
import { openDialog } from "@store/dialogs";
import { FileToStorydocDialog } from "../components/file-to-storydoc-dialog";
import type { ImportEntryPoint } from "../stores/file-to-storydoc-generation.store";
import { IMPORT_DIALOG_ID } from "./import-dialog-id";

export type OpenImportDialogOptions = {
  file?: File;
  initialStep?: "source" | "choosing";
  initialSource?: "drive";
  entryPoint: ImportEntryPoint;
  importId?: string;
};

// The single place the modal is opened from: buttons, the chevron menu, the
// completion toast and the placeholder row all land in the same dialog.
export const openImportDialog = (opts: OpenImportDialogOptions) => {
  const open = store
    .getState()
    .dialogs.some((d: { id: string }) => d.id === IMPORT_DIALOG_ID);
  if (open) return;
  store.dispatch(
    openDialog({
      id: IMPORT_DIALOG_ID,
      content: FileToStorydocDialog,
      props: {
        ...opts,
        className: "tw-mt-8",
        overlayClassName:
          "tw-items-start tw-bg-black/80 tw-backdrop-blur-[2px]",
      },
    }),
  );
};
